import { IUser } from '../interfaces/user.interface';
import { IUitnodigingResultaat, Uitkomst } from '../interfaces/leden.interface';

/**
 * Mag deze gebruiker de ledenlijst openen? Een club_admin (ook via "Open als
 * club"), of een teambeheerder van minstens één team (claim team_admin). Niet
 * in een league-omgeving. Alleen voor het menu en de route: auth kijkt het
 * bij elke aanvraag zelf na in de database (LedenService.Wie).
 */
export function beheertLeden(user: IUser | null | undefined): boolean {
  if (!user || user.home_club) {
    return false;
  }
  return beheertClub(user) || (user.team_admin?.length ?? 0) > 0;
}

/**
 * club_admin van deze club (ook via "Open als club")? Die ziet op Users ook
 * "All teams": iedereen in de club. Niet in een league-omgeving.
 */
export function beheertClub(user: IUser | null | undefined): boolean {
  if (!user || user.home_club) {
    return false;
  }
  const rol = typeof user.role === 'string' ? user.role : user.role?.key;
  return rol === 'club_admin';
}

/**
 * De losse adressen uit wat iemand in het vak plakt: gescheiden door komma's,
 * puntkomma's, spaties of regels. "Naam <naam@club.nl>" uit een mailprogramma
 * mag ook. Dubbele adressen (hoofdletters tellen niet) gaan eruit.
 */
export function splitsAdressen(tekst: string | null | undefined): string[] {
  const gezien = new Set<string>();
  const adressen: string[] = [];
  for (const stuk of (tekst ?? '').split(/[\s,;]+/)) {
    const adres = stuk.replace(/^[<"'(]+|[>"')]+$/g, '').trim();
    if (!adres.includes('@')) {
      continue;
    }
    const sleutel = adres.toLowerCase();
    if (!gezien.has(sleutel)) {
      gezien.add(sleutel);
      adressen.push(adres);
    }
  }
  return adressen;
}

/** Gelukt: uitgenodigd, toegevoegd of stond er al in. */
export const GELUKT: readonly Uitkomst[] = ['invited', 'added', 'already_member'];

/** De adressen die niet konden, om ze in het venster te laten zien. */
export function nietGelukt(resultaten: IUitnodigingResultaat[]): IUitnodigingResultaat[] {
  return resultaten.filter(r => !GELUKT.includes(r.outcome));
}

/** Naam voor de lijst; zonder naam (net uitgenodigd) het e-mailadres. */
export function lidNaam(lid: { firstName?: string; lastName?: string; email?: string }): string {
  const naam = `${lid.firstName ?? ''} ${lid.lastName ?? ''}`.trim();
  return naam || lid.email || '';
}

/** Zoeken op naam of e-mailadres, hoofdletters tellen niet. */
export function lidPast(lid: { firstName?: string; lastName?: string; email?: string }, zoek: string): boolean {
  const z = (zoek ?? '').trim().toLowerCase();
  if (!z) {
    return true;
  }
  return lidNaam(lid).toLowerCase().includes(z) || (lid.email ?? '').toLowerCase().includes(z);
}
